import React from 'react';
import './Band.css'; // Подключение стилей


const members = [
    {
        name: 'Владимир Минц-Копленок',
        role: 'Вокал / Гитара/ Лидер группы',
        bio: 'Харизматичный лидер и голос группы.',
        photo: 'images/Band/Владимир.png',
    },
    {
        name: 'Игорь Минаков',
        role: 'Гитарист',
        bio: 'Мастер риффов и мелодий.',
        photo: 'images/Band/Игорь.png',
    },
    {
        name: 'Константин Аубекеров',
        role: 'Басист',
        bio: 'Идеально ложится по контуру.',
        photo: 'images/Band/Костя.png',
    },
    {
        name: 'Денис Марков',
        role: 'Барабанщик',
        bio: 'Страстно задает ритм.',
        photo: 'images/Band/Денис.png',
    },
];


function Band () {

return (

    <div id="band" className="band-section">
        <h2>Актуальный состав</h2>
        <div className="band-cards">
            {members.map((member, index) => (
                <div key={index} className="band-card">
                    <img src={member.photo} alt={member.name} className="band-photo" />
                    <h3>{member.name}</h3>
                    <p className="band-role">{member.role}</p>
                    <p className="band-bio">{member.bio}</p>
                </div>
            ))}
        </div>

        <div className="band-history">
            <h2>История группы</h2>
            <p>
                От скромного начала до того, как стать известным именем в музыкальной индустрии, 
                наша группа всегда расширяла границы дозволенного. Каждый участник привносит свой 
                неповторимый колорит, объединяясь для создания незабываемых мелодий и выступлений. 
                За годы преданности делу и страсти мы завоевали нишу в сердцах наших поклонников.
            </p>
            <h3>Подарок</h3>
            <p>
                В настоящее время мы работаем над нашим следующим альбомом, исследуя новые звуки и идеи,
                 оставаясь верными нашим корням. Путешествие, которое мы проделали до сих пор, 
                 было невероятным, и мы рады поделиться нашей музыкой со всем миром.
            </p>
            <h3>Будущее</h3>
            <p>
                Учитывая планы на мировое турне и сотрудничество с другими артистами, 
                будущее открывает бесконечные возможности.
                Мы стремимся продолжать вдохновлять своей музыкой и общаться с поклонниками по всему миру.
            </p>
            
            <div className="join-vk">
                <h4>Хотите знать больше о нашем творчестве и последних событях подписывайтесь на нас в  VK:</h4>
                <a href="https://vk.com/mintskoplenok" target="_blank" rel="noopener noreferrer" className="vk-button">Присоединяйтесь к нам VK</a>
            </div>
            
        </div>
    </div>
)

}

    export default Band;